export const isValidReportId = (reportId: string): boolean => {
  if (typeof reportId !== 'string' || reportId.length === 0) {
    return false;
  }

  const objectIdRegex = /^[0-9a-fA-F]{24}$/;
  return objectIdRegex.test(reportId);
};
